// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2yAOu","title":"FrontImage_title__JOvhF"};